const ModalRoot = ({ children }: any) => (
  <div
    id="root-layout"
    className="overflow-y-hidden absolute top-0 bottom-0 left-0 right-0 pointer-events-none max-w-full"
  >
    {children}
  </div>
);

export default ModalRoot;
